import Resources from './resources/Resources.vue'
import Products from './products/Products.vue'
import Deals from './deals/Deals.vue'
import UpsertResourceWrapper from './resources/edit/UpsertResourceWrapper.vue'
import UpsertProductWrapper from './products/edit/UpsertProductWrapper.vue'
import UpsertDealWrapper from './deals/edit/UpsertDealWrapper.vue'

const { businessUnitDomain, enabledFeatures, priceIncludesTaxDefaultValue } = window.briqState || {}

export default [
  {
    path: '/inventory',
    redirect: '/inventory/deals',
  },
  {
    path: '/inventory/resources',
    component: Resources,
    name: 'Resources',
    props: true,
    meta: {
      title: 'Resources',
    },
  },
  {
    path: '/inventory/resources/:resourceKey/edit',
    component: UpsertResourceWrapper,
    name: 'EditResource',
    props: true,
    meta: {
      title: 'Resources | Edit',
    },
  },
  {
    path: '/inventory/resources/create',
    component: UpsertResourceWrapper,
    name: 'CreateResource',
    props: true,
    meta: {
      title: 'Resources | Create',
    },
  },
  {
    path: '/inventory/products',
    component: Products,
    name: 'Products',
    props: true,
    meta: {
      title: 'Products',
    },
  },
  {
    path: '/inventory/products/:productKey/edit',
    component: UpsertProductWrapper,
    name: 'EditProduct',
    props: route => ({
      productKey: route.params.productKey,
      showAccountingFields: businessUnitDomain === 'kartfabrique',
    }),
    meta: {
      title: 'Products | Edit',
    },
  },
  {
    path: '/inventory/products/create',
    component: UpsertProductWrapper,
    name: 'CreateProduct',
    props: {
      priceIncludesTaxDefaultValues: priceIncludesTaxDefaultValue,
      showAccountingFields: businessUnitDomain === 'kartfabrique',
    },
    meta: {
      title: 'Products | Create',
    },
  },
  {
    path: '/inventory/deals',
    component: Deals,
    name: 'Deals',
    props: true,
    meta: {
      title: 'Deals',
    },
  },
  {
    path: '/inventory/deals/:dealKey/edit',
    component: UpsertDealWrapper,
    name: 'EditDeal',
    props: route => ({
      dealKey: route.params.dealKey,
    }),
    meta: {
      title: 'Deals | Edit',
    },
  },
  {
    path: '/inventory/deals/create',
    component: UpsertDealWrapper,
    name: 'CreateDeal',
    meta: {
      title: 'Deals | Create',
    },
  },
]
